export enum ENavigationRoute {

    Login = 'login',
    Error = 'error',

    WeeklyList = 'weekly-list',
    InterventionList = 'intervention-list',
    Intervention = 'intervention',
    Zone = 'zone',

    DrawingTool = 'drawing-tool',
    Pointage = 'pointage',
    Scan = 'scan',
    Metrologie = 'metrologie',
    Generateur = 'generateur',
    Endoscope = 'endoscope',
    Plan = 'Plan',
    Appareils = 'Appareils'
}

